import { render, staticRenderFns } from "./Bluetooth.vue?vue&type=template&id=25a239f2&scoped=true&"
import script from "./Bluetooth.vue?vue&type=script&lang=js&"
export * from "./Bluetooth.vue?vue&type=script&lang=js&"
import style0 from "./Bluetooth.vue?vue&type=style&index=0&id=25a239f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a239f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCard,VContainer,VDialog,VIcon,VProgressCircular,VSnackbar})
